import { useEffect } from 'react';
import { Container, Row, Col, Button, Nav, NavItem } from 'reactstrap';
import { NavLink, useOutletContext } from 'react-router-dom';
import { withTranslator } from '@front-activerse/common-components';
import { useLazyQuery } from '@apollo/client';
import {
  formatLongDate,
  createDateObject,
  callNativeRestorePurchases,
  callNativeApp,
  callNativeMobileApp,
  AccessToQuery,
} from '@front-activerse/common-components';

import Layout from '../Layout/Layout';
import { withMobileAppMode } from '@front-activerse/common-components';
import { useAppContext } from '@front-activerse/common-components';
import TitleBar from '../Layout/TitleBar';

const UnauthorizedException = ({
  accessTo,
  mobileAppMode,
  mobileApp,
  t,
  mealPlanNavigation = undefined,
}) => {
  const [fetchAccess, { loading }] = useLazyQuery(AccessToQuery, { fetchPolicy: 'network-only' });

  const { trackFirebaseEvent } = useOutletContext();

  useEffect(() => {
    console.log('UnauthorizedException mounted');
    trackFirebaseEvent('LapsedUsers_Promo');
  }, []);

  const {
    images: { unauthorized },
    consts: { APP_BRAND },
  } = useAppContext();

  const checkAccess = async () => {
    if (mobileApp.os && mobileApp.os.toLowerCase().startsWith('ios')) {
      callNativeRestorePurchases();
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const response = await fetchAccess();
    if (response.data.me.diet.accessTo) {
      const accessTo = createDateObject(response.data.me.diet.accessTo);
      if (accessTo >= today) {
        window.location.reload();
      }
    }
  };

  const handleClick = (event) => {
    if (mobileAppMode) {
      event.preventDefault();

      if (APP_BRAND === 'shestrong') {
        // old way
        callNativeApp('/', 'buy-diet');

        // new way
        callNativeMobileApp({
          action: 'open_modal',
          payload: {
            target: 'price_list',
          },
        });
      } else if (APP_BRAND === 'dtbaPl') {
        callNativeApp('/', 'buy-diet');
      } else {
        callNativeMobileApp({
          action: 'open_modal',
          payload: {
            target: 'price_list',
          },
        });
      }
    }
  };

  let refreshLabel = t('accessUnauthorizedException.refresh.button');

  if (mobileApp.os && mobileApp.os.toLowerCase().startsWith('ios')) {
    refreshLabel = t('accessUnauthorizedException.restorePurchases.button');
  }

  let title;
  let paragraphText;

  if (accessTo) {
    title = t('accessUnauthorizedException.title', {
      accessTo: formatLongDate(accessTo),
    });
    paragraphText = t('app.accessUnauthorizedException.content');
  } else {
    title = t('accessUnauthorizedException.title');
    paragraphText = t('app.accessUnauthorizedException.content');
  }

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('meals.navbarTitle')}</TitleBar>
      <div className="page-template-other full-height3">
        <Container className="py-md-4">
          <Row>
            <Col lg={{ size: 4, offset: 4 }}>
              <div className="page-container">
                {mealPlanNavigation && mealPlanNavigation.length > 0 && (
                  <div className="sub-navigation text-center">
                    <Container>
                      <Nav className="d-block">
                        {mealPlanNavigation.map((item) => (
                          <NavItem className="w-50">
                            <NavLink to={item.path} replace={true} className="nav-link">
                              {t(item.translationKey)}
                            </NavLink>
                          </NavItem>
                        ))}
                      </Nav>
                    </Container>
                  </div>
                )}
                <div
                  className={
                    mobileAppMode
                      ? 'other-container text-center d-flex align-items-center min-height2'
                      : 'other-container text-center d-flex align-items-center'
                  }
                >
                  <div>
                    <img
                      className="img-fluid mb-xl"
                      srcSet={`${unauthorized} 100w`}
                      sizes="50px"
                      alt=""
                    />
                    <h2 className="title-medium semi-bold">{title}</h2>
                    <p className="mb-xl text-text-variant-color text-center">{paragraphText}</p>

                    {mobileAppMode ? (
                      <Button
                        color="primary"
                        className="w-100 mb-s"
                        onClick={(event) => handleClick(event)}
                      >
                        {t('accessUnauthorizedException.buyNow.button')}
                      </Button>
                    ) : (
                      <a
                        className="btn btn-primary w-100 mb-s"
                        href={`${import.meta.env.VITE_LANDING_PAGE_URL}/#buy`}
                      >
                        {t('accessUnauthorizedException.buyNow.button')}
                      </a>
                    )}

                    <Button
                      color="secondary"
                      outline
                      className="w-100"
                      onClick={checkAccess}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          />{' '}
                          <span>{refreshLabel}</span>
                        </>
                      ) : (
                        refreshLabel
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default withMobileAppMode(withTranslator(UnauthorizedException));
